import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { createGlobalStyle } from 'styled-components'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { AppLayout } from './components/layout/AppLayout'
import { LoginPage } from './pages/auth/LoginPage'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { RecipesPage } from './pages/recipes/RecipesPage'
import { UsersPage } from './pages/users/UsersPage'
import { UserDetailPage } from './pages/users/UserDetailPage'
import { ProfilePage } from './pages/profile/ProfilePage'
import { AllergensPage } from './pages/allergens/AllergensPage'
import { FoodGroupsPage } from './pages/food-groups/FoodGroupsPage'
import { SeasonsPage } from './pages/seasons/SeasonsPage'
import { UnitsPage } from './pages/units/UnitsPage'
import { IngredientsPage } from './pages/ingredients/IngredientsPage'
import { CatalogReviewPage } from './pages/catalog-review/CatalogReviewPage'
import { ApiDocsPage } from './pages/api-docs/ApiDocsPage'
import { SupportPage } from './pages/support/SupportPage'
import { SupportDetailPage } from './pages/support/SupportDetailPage'

const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    html, body, #root {
        height: 100%;
    }
    body {
        font-family: 'DM Sans', sans-serif;
        background: #faf7fc;
    }
`

export default function App() {
  return (
    <AuthProvider>
      <GlobalStyle />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="ingredients" element={<IngredientsPage />} />
            <Route path="recipes" element={<RecipesPage />} />
            <Route path="food-groups" element={<FoodGroupsPage />} />
            <Route path="seasons" element={<SeasonsPage />} />
            <Route path="allergens" element={<AllergensPage />} />
            <Route path="units" element={<UnitsPage />} />
            <Route path="catalog-review" element={<CatalogReviewPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:id" element={<UserDetailPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="api-docs" element={<ApiDocsPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="support/:id" element={<SupportDetailPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
